<template>
  <a-modal v-model="visible" :title="$t('租赁_申请订单作废')" @ok="submit">
    <h4>{{$t('提示_操作申请订单作废')}}</h4>
    <div>
      <template v-for="order in orderList"><a-tag>{{order.XB_SHEET_CODE}}</a-tag></template>
    </div>
    <a-textarea class="margin-top-10" v-model="applyCancelRemark" :auto-size="{minRows: 5}" :placeholder="$t('租赁_请填写申请作废原因')"/>
  </a-modal>
</template>

<script>
export default {
  name: 'apply-order-cancel-modal',
  data () {
    return {
      visible: false,
      boxList: [],
      applyCancelRemark: '',
    };
  },
  computed: {
    orderList(){
      const orderList = [], orderMap = {};
      this.boxList.forEach(box => {
        if(!orderMap[box.XB_SHEET_CODE]){
          orderMap[box.XB_SHEET_CODE] = { XB_SHEET_CODE: box.XB_SHEET_CODE, XC_MASTER_ID: box.XC_MASTER_ID, BOX_LIST: [] };
          orderList.push(orderMap[box.XB_SHEET_CODE]);
        }
        orderMap[box.XB_SHEET_CODE].BOX_LIST.push(box);
      });
      return orderList;
    },
  },
  methods: {
    open(boxList){
      this.boxList = boxList;
      this.applyCancelRemark = '';
      this.visible = true;
    },
    submit(){
      const submitData = [];
      this.orderList.forEach(order => {
        submitData.push({ "MASTER_ID": order.XC_MASTER_ID, "CANCEL_DESC": this.applyCancelRemark, CANCEL_STATUS: 20421002 })
      });

      this.$h5Api({
        type: '4087',
        data: submitData,
        showMessage: true,
      }).then(data => {
        this.visible = false;
        this.$message.info(data.message);
        this.$emit('refresh');
      });
    },
  },
};
</script>

<style lang="scss">

</style>